const initialState = {
  skills: {
    removed: [],
    merged: [],
    approved: [],
  }
};

const sectionBySkillAction = {
  'SKILL_REMOVED@UPDATE': 'removed',
  'SKILL_MERGED@UPDATE': 'merged',
  'SKILL_APPROVED@UPDATE': 'approved',
};

// TODO: pop internich notifikaci? napr. po odbaveni SKILL_REMOVED at nezustavaji ve storu

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SKILL_REMOVED@UPDATE':
    case 'SKILL_MERGED@UPDATE':
    case 'SKILL_APPROVED@UPDATE': {
      const section = sectionBySkillAction[action.type];
      if (!(section && action.payload.skill && action.payload.skill.id)) {
        return state;
      }

      return {
        ...state,
        skills: {
          ...state.skills,
          [section]: [
            ...state.skills[section],
            action.type === 'SKILL_MERGED@UPDATE' ? action.payload : action.payload.skill
          ]
        }
      };
    }
    default:
      return state;
  }
}

export const selectors = {
  getSkillNotifications(state) {
    return state.notifications.skills;
  }
};
